/**
 * Shared product-map stage presentation (`in_dev` … `ga`, plus `deprecated`) —
 * options for `EditableBadge` and the badge variant per stage. Used by the
 * area header, capability row/drawer and rule rows so they stay in lock-step.
 * The server enforces rule <= capability <= area (`PRODUCT_MAP_STAGE_RANK`).
 *
 * @module features/product-map/stage
 */

import { PRODUCT_MAP_STATUSES, type ProductMapStatus } from '@chatsdet/types';

export const STAGE_LABEL: Record<ProductMapStatus, string> = {
  in_dev: 'In dev',
  alpha: 'Alpha',
  beta: 'Beta',
  ga: 'GA',
  deprecated: 'Deprecated',
};

export const STAGE_OPTIONS: Array<{ id: ProductMapStatus; label: string }> = PRODUCT_MAP_STATUSES.map((id) => ({
  id,
  label: STAGE_LABEL[id],
}));

export const STAGE_VARIANT: Record<ProductMapStatus, 'secondary' | 'warning' | 'default' | 'success' | 'destructive'> = {
  in_dev: 'secondary',
  alpha: 'warning',
  beta: 'default',
  ga: 'success',
  deprecated: 'destructive',
};
